import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import './_style.scss';
const CurrencyChip = ({ currency, size, hasMargin = false, variant = 'default', }) => (_jsx("div", { className: classNames('currency-chip', {
        '--small': size === 'small',
        '--medium': size === 'medium',
        '--large': size === 'large',
        '--secondary': variant === 'secondary',
        '--padded': hasMargin,
    }), "data-testid": "currency-indicator", children: currency }));
export default CurrencyChip;
